export const GET_PRICING = 'get-pricing';
const getPricing = () => ({ type: GET_PRICING });
export default getPricing;
